import { Area } from './area.model'


export default class AreaService{

    fetchareas(): Promise<Area[]> {
        return fetch('api/area/areas')
            .then(response => response.json() as Promise<Area[]>);            
    }

    /**
     * Posts an area to the server
     * @param area
     */
    postarea(area: Area, parentId: number | undefined): Promise<any> {
        area.parentId = parentId;
        return fetch('api/area/addarea',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(area)
            })
            .then(response => response.status);
    }

    /**
     * Posts an area to the server
     * @param area
     */
    updatearea(area: Area): Promise<any> {
        return fetch('api/area/updatearea',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(area)
            })
            .then(response => response.status);
    }


    /**
     * Posts an area to the server
     * @param areas
     */
    deleteareas(areas: Area[]): Promise<any> {
        return fetch('api/area/deletearea',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(areas)
            })
            .then(response => response.status);
    }
}